import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=af7bc42a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=af7bc42a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7bc42a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af7bc42a')) {
      api.createRecord('af7bc42a', component.options)
    } else {
      api.reload('af7bc42a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=af7bc42a&scoped=true&", function () {
      api.rerender('af7bc42a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25WzVhz75a9O0/JS/comp/PopupBox.vue"
export default component.exports